<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_421_8308)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M-0.5 12C-0.5 11.7239 -0.276142 11.5 0 11.5H24C24.2761 11.5 24.5 11.7239 24.5 12C24.5 12.2761 24.2761 12.5 24 12.5H0C-0.276142 12.5 -0.5 12.2761 -0.5 12Z"
        fill="#434243"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 -0.5C12.2761 -0.5 12.5 -0.276142 12.5 0V24C12.5 24.2761 12.2761 24.5 12 24.5C11.7239 24.5 11.5 24.2761 11.5 24V0C11.5 -0.276142 11.7239 -0.5 12 -0.5Z"
        fill="#434243"
      />
    </g>
    <defs>
      <clipPath id="clip0_421_8308">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "IconAbiPlus"
};
</script>
